const hasWindow = typeof window !== 'undefined'

export function hasAndroidBridge(): boolean {
  return hasWindow && !!window.AndroidJSInterface
}

export function hasIOSBridge(): boolean {
  return hasWindow
    && !!window.webkit?.messageHandlers
    && typeof window.webkit.messageHandlers === 'object'
}

function uaIsAndroid(): boolean {
  if (!hasWindow) return false
  const ua = navigator.userAgent || ''

  return /Android/i.test(ua)
}

/**
 * Примитивная проверка iOS по userAgent + iPadOS 13+ (MacIntel + touch).
 */
function uaIsIOS(): boolean {
  if (!hasWindow) return false
  const ua = navigator.userAgent || ''
  const platform = navigator.platform || ''
  const maxTouch = navigator.maxTouchPoints || 0

  const isiOSUA = /iPhone|iPad|iPod/i.test(ua)
  const isIPadOS13Plus = platform === 'MacIntel' && maxTouch > 1

  return isiOSUA || isIPadOS13Plus
}

export const isAndroid = (): boolean => hasAndroidBridge() || uaIsAndroid()

export const isIOS = (): boolean => hasIOSBridge() || uaIsIOS()
